// widgets/AnomaliesWidget.jsx (uses /reports/anomalies)
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api';
import { AlertTriangle } from 'lucide-react';
import '../App.css';
import './Widgets.css';

export default function AnomaliesWidget() {
  const [anomalies, setAnomalies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnomalies = async () => {
      try {
        const { data } = await api.get('/reports/anomalies', {
          params: { table: 'all_inventory', limit: 10 },
        });
        setAnomalies(data.rows || []);
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load anomalies');
      } finally {
        setLoading(false);
      }
    };
    fetchAnomalies();
  }, []);

  if (loading) return <div className="widget-loading">Loading...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget anomalies">
      <h3 className="widget-title">Recent Anomalies</h3>
      <ul>
        {anomalies.map((a) => (
          <li key={a.id}>
            <AlertTriangle size={16} /> {a.description} (Record {a.record_id})
          </li>
        ))}
        {anomalies.length === 0 && <li>No anomalies detected</li>}
      </ul>
    </div>
  );
}